export const BoardMembers = {
  BoardMembers: "boardMembers" as const,
}

export const BoardMember = {
  Name: "name" as const,
  SocialSecurityNumber: "socialSecurityNumber" as const,
  Mail: "mail" as const,
  PhoneNumber: "phoneNumber" as const,
  Roles: "roles" as const,
}

export const Role = {
  RoleName: "roleName" as const,
  AppointmentDate: "appointmentDate" as const,
}

export const BoardMemberWithRoles = {
  Name: "name" as const,
  SocialSecurityNumber: "socialSecurityNumber" as const,
  Mail: "mail" as const,
  PhoneNumber: "phoneNumber" as const,
  Roles: "roles" as const,
}

export const BoardMemberDisplay = {
  BoardMember: "boardMember" as const,
  SocialSecurityNumber: "socialSecurityNumber" as const,
  Mail: "mail" as const,
}

export const BoardMembersDisplay = {
  BoardMembers: "boardMembers" as const,
}

